import store from '../../../../store';
import api from '../../../api'

export default {
    // Leave Application API
    getLeaveApplications(params) {
        return api.get('/hr/leave-applications', { params });
    },
    getLeaveApplicationsCalendar(params) {
        return api.get('/hr/leave-applications/calendar', { params });
    },
    addLeaveApplication(params) {
        return api.post('/hr/leave-applications', params);
    },
    showLeaveApplication(id) {
        return api.get(`/hr/leave-applications/${id}`);
    },
    updateLeaveApplication(id, params) {
        return api.put(`/hr/leave-applications/${id}`, params);
    },
    updateLeaveApplicationStatus(id, params) {
        return api.put(`/hr/leave-applications/${id}/status`, params);
    },
    deleteLeaveApplication(id) {
        return api.delete(`/hr/leave-applications/${id}`);
    },

    // Leave Type API
    getLeaveTypes(params) {
        return api.get('/hr/leave-types', { params });
    },
    addLeaveType(params) {
        return api.post('/hr/leave-types', params);
    },
    showLeaveType(id) {
        return api.get(`/hr/leave-types/${id}`);
    },
    updateLeaveType(id, params) {
        return api.put(`/hr/leave-types/${id}`, params);
    },
    deleteLeaveType(id) {
        return api.delete(`/hr/leave-types/${id}`);
    },

    // Legacy endpoints (for backward compatibility)
    addLeaveRequest(params) {
        return this.addLeaveApplication(params);
    },
    getLeaveRequest(params) {
        return this.getLeaveApplications(params);
    },
    updateLeaveRequest(params) {
        return this.updateLeaveApplication(params.id, params.payload);
    },
    deleteLeaveRequest(params) {
        return this.deleteLeaveApplication(params);
    },
    showLeaveRequest(params) {
        return this.showLeaveApplication(params);
    },
    addLeaveTypes(params) {
        return this.addLeaveType(params);
    },
    updateLeaveTypes(params) {
        return this.updateLeaveType(params.id, params.payload);
    },
    deleteLeaveTypes(params) {
        return this.deleteLeaveType(params);
    },
    showLeaveTypes(params) {
        return this.showLeaveType(params);
    },

}